import { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import { formatDate } from '../../../../utils/util';

import DatePicker from '../../../common/inputs/date-picker/DatePicker';
import Dropdown from '../../../common/inputs/dropdown/Dropdown';
import TextInput from '../../../common/inputs/text-input/TextInput';
import Button from '../../../common/button/Button';

import { ReactComponent as SearchIcon } from '../../../../resources/icons/search.svg';

import './e-wallet.scss';

const EWallet = ({ entries }) => {
  const [fromDate, setFromDate] = useState(undefined);
  const [toDate, setToDate] = useState(undefined);
  const [activity, setActivity] = useState({ label: 'All Activity', value: 'All Activity' });
  const [keywords, setKeywords] = useState('');
  const [filteredEntries, setFilteredEntries] = useState([]);

  const statusOptions = useRef([
    { label: 'All Activity', value: 'All Activity' },
    { label: 'Credit', value: 'Credit' },
    { label: 'Debit', value: 'Debit' },
  ]);

  const resetFilters = () => {
    setActivity({ label: 'All Activity', value: 'All Activity' });
    setKeywords('');
    setFromDate(undefined);
    setToDate(undefined);
  };

  const isDebit = (entry) => parseFloat(entry.debit.replace(/,$/, '.')) > 0;

  useEffect(() => {
    let filteredEntries = [...entries];
    if (activity.value === 'Debit') {
      filteredEntries = filteredEntries.filter((entry) => isDebit(entry));
    } else if (activity.value === 'Credit') {
      filteredEntries = filteredEntries.filter((entry) => !isDebit(entry));
    }

    if (fromDate) {
      filteredEntries = filteredEntries.filter((entry) => fromDate <= new Date(entry.date));
    }

    if (toDate) {
      filteredEntries = filteredEntries.filter((entry) => toDate >= new Date(entry.date));
    }

    if (keywords) {
      filteredEntries = filteredEntries.filter((entry) =>
        entry.activity.toLowerCase().includes(keywords.toLowerCase())
      );
    }

    setFilteredEntries(filteredEntries);
  }, [entries, fromDate, toDate, activity, keywords]);

  const renderTable = () => (
    <table className="e-wallet__table">
      <thead className="e-wallet__table__header">
        <tr>
          <th>Date</th>
          <th>Activity</th>
          <th>Debit</th>
          <th>Credit</th>
          <th>Balance</th>
        </tr>
      </thead>
      <tbody className="e-wallet__table__body">
        {filteredEntries.map((entry, index) => {
          const { date, activity, debit, credit, balance } = entry;

          return (
            <tr key={index}>
              <td>{formatDate(date)}</td>
              <td>{activity}</td>
              <td>{debit}</td>
              <td>{credit}</td>
              <td>{balance}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );

  return (
    <section className="e-wallet" data-testid="e-wallet">
      <section className="e-wallet__filter">
        <h1 className="e-wallet__title">ATP-Wallet</h1>
        <h2 className="e-wallet__subtitle">Filter</h2>
        <section className="e-wallet__filters-container">
          <section className="e-wallet__filters">
            <DatePicker name="from-date" placeholder="From" value={fromDate} onChange={(date) => setFromDate(date)} />
            <DatePicker name="from-date" placeholder="To" value={toDate} onChange={(date) => setToDate(date)} />
            <Dropdown
              name="activity"
              placeholder="Activity"
              value={activity}
              options={statusOptions.current}
              onChange={(option) => setActivity(option)}
            />
            <TextInput
              name="keywords"
              placeholder="Keywords"
              value={keywords}
              onChange={({ target }) => setKeywords(target.value)}
              icon={<SearchIcon className="e-wallet__search-icon" />}
            />
          </section>
          <Button className="e-wallet__reset-filter-button" onClick={resetFilters}>
            Reset Filters
          </Button>
        </section>
      </section>

      <section className="e-wallet__table-container">
        {filteredEntries.length === 0 ? <p>No Entries Found</p> : renderTable()}
      </section>
    </section>
  );
};

EWallet.propTypes = {
  entries: PropTypes.arrayOf(PropTypes.shape({})),
};

EWallet.defaultProps = {
  entries: [],
};

export default EWallet;
